import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import New from './components/New'
import List from './components/List'
import { DetailBusiness } from './components/Detail'
import SubcontractModules from './modules/Subcontract'
import ProcessModules from './modules/Process'
import PartnerModules from './modules/Partner'
import SampleModules from './modules/Sample'
import Overview from './components/Overview'
import ContractNegotiation from './modules/Negotiation/components'

const ContractModule: RouteObject = {
    path: 'contracts',
    children: [
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'overview/:type',
            element: <Overview />,
        },
        {
            path: '',
            element: <List />,
        },
        {
            path: ':contractID',
            element: <DetailBusiness />,
        },
        {
            path: ':contractID/subcontracts/:subcontractID',
            element: <SubcontractModules.Detail />,
        },
        {
            path: ':contractID/processes',
            element: <ProcessModules.List />,
        },
        {
            path: 'partners',
            element: <PartnerModules.List />,
        },
        {
            path: 'partners/suppliers/:partnerID',
            element: <PartnerModules.SupplierDetail />,
        },
        {
            path: 'partners/:contractID',
            element: <PartnerModules.Detail />,
        },
        {
            path: 'samples',
            element: <SampleModules.List />,
        },
        {
            path: 'negotiations',
            element: <ContractNegotiation.List />,
        },
        {
            path: 'negotiations/:id',
            element: <ContractNegotiation.Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ContractModule
